import React from 'react';
import { get } from 'lodash';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import { getTextColor } from '@components/overview-dashboard/metrics-container/spi-widget/SPIMetricsText';
import { calculatePctShare } from '@utils/table/pctShare';
import { StyledCell } from './styled';

function Cell({ rowData, column, cellData, container }) {
  const { dataKey } = column;
  const pctShare = calculatePctShare({
    value: rowData[dataKey],
    pctShareMaxValue: get(container, ['props', 'headerProps', 'pctShareMaxValues', dataKey], 0),
  });

  const textStyle: React.CSSProperties = {};
  let classStr = '';
  if (column.key === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 600;
    classStr = 'color-critical';
  }

  return (
    <StyledCell pctShare={pctShare}>
      <span style={textStyle} className={classStr}>
        {cellData}
      </span>
    </StyledCell>
  );
}

export default Cell;
